export default __webpack_public_path__ + "static/whatsup-bg-e0e3b590c7016761bd58166ece25c7fc.png";